type ErrorContext = Readonly<Record<string, string | number | boolean | undefined>>

export function reportUnexpectedError(error: unknown, context: ErrorContext): void {
  const normalizedError = error instanceof Error ? error : new Error('Unknown error')

  console.error({
    event: 'unexpected_error',
    errorName: normalizedError.name,
    errorMessage: normalizedError.message,
    ...context,
  })
}
